import React, { useContext } from "react";
import { Select } from "antd";
import AppContext from "../../config/AppContext";

export default function SwitchOrg() {
  const { switchOrgList, selectedOrg, getSelectedOrg } = useContext(AppContext);
  const { Option } = Select;
  const isGroupOrgUser = localStorage.getItem("isGroupOrgUser");
  return (
    <div>
      {selectedOrg !== null &&
      selectedOrg !== undefined &&
      selectedOrg !== "" &&
      (isGroupOrgUser === true || isGroupOrgUser === "true") ? (
        <Select
          id="reset"
          size="large"
          placeholder={selectedOrg}
          optionFilterProp="children"
          onChange={(value) => getSelectedOrg(switchOrgList, value)}
          value={selectedOrg}
          style={{
            width: "100%",
          }}
        >
          {switchOrgList?.map((e, i) => (
            <Option key={i} value={e?.id}>
              {e?.orgName}
            </Option>
          ))}
        </Select>
      ) : (
        <div></div>
      )}
    </div>
  );
}
